import { render, staticRenderFns } from "./NominaDashboard.vue?vue&type=template&id=4a8d0385"
import script from "./NominaDashboard.vue?vue&type=script&lang=js"
export * from "./NominaDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports